import { render } from "./LastScoreWidget.vue?vue&type=template&id=508290c6&scoped=true"
import script from "./LastScoreWidget.vue?vue&type=script&lang=js"
export * from "./LastScoreWidget.vue?vue&type=script&lang=js"

import "./LastScoreWidget.vue?vue&type=style&index=0&id=508290c6&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508290c6"]])

export default __exports__